module.exports = __webpack_public_path__ + "static/media/Search and filter.36a758d6.jpg";